<div class="p-4">
    <h2 class="text-lg font-semibold mb-4">Global Search</h2>

    @if (vm$ | async; as vm) {
    @if (vm.query) {
    <div class="text-sm mb-2">
        <p>Results for "{{ vm.query }}"</p>
    </div>
    }

    @if (vm.status === 'idle' && !vm.query) {
    <div class="text-sm text-gray-500">
        Enter a term in the toolbar search to get started.
    </div>
    }

    @if (vm.status === 'loading') {
    <div class="text-sm text-gray-500">
        Loading search results...
    </div>
    }

    @if (vm.status === 'error') {
    <div class="text-sm text-red-600">
        Something went wrong loading search results. Please try again.
    </div>
    }

    @if (vm.status === 'success') {
    <div class="grid md:grid-cols-2 gap-4 mt-2">
        <section class="flex flex-col min-h-0">
            <h3 class="font-semibold mb-2">Participants</h3>
            <div class="border border-gray-200 rounded max-h-[320px] overflow-y-auto">
                @if (vm.results.participantSearchResults.length) {
                <div class="space-y-1">
                    @for (p of vm.results.participantSearchResults; track p.participantId) {
                    <div class="grid grid-cols-[2fr_2fr_1fr_1fr] gap-2 text-xs items-center border-b border-gray-200 py-1 px-2 cursor-pointer hover:bg-gray-50"
                        (click)="goToParticipant(p)">
                        <div>{{ p.projectName }}</div>
                        <div>{{ p.email }}</div>
                        <div>{{ p.participantId }}</div>
                        <div>{{ p.uniqueId }}</div>
                    </div>
                    }
                </div>
                } @else {
                <p class="text-sm text-gray-500 px-2 py-2">No participants found.</p>
                }
            </div>
        </section>

        <section class="flex flex-col min-h-0">
            <h3 class="font-semibold mb-2">Projects</h3>
            <div class="border border-gray-200 rounded max-h-[320px] overflow-y-auto">
                @if (vm.results.projectSearchResults.length) {
                <div class="space-y-1">
                    @for (p of vm.results.projectSearchResults; track p.projectId) {
                    <div class="grid grid-cols-[2fr_1fr] gap-2 text-xs items-center border-b border-gray-200 py-1 px-2 cursor-pointer hover:bg-gray-50"
                        (click)="goToProject(p)">
                        <div>{{ p.projectName }}</div>
                        <div>{{ p.createdDate | date: 'short' }}</div>
                    </div>
                    }
                </div>
                } @else {
                <p class="text-sm text-gray-500 px-2 py-2">No projects found.</p>
                }
            </div>
        </section>
    </div>
    }
    }
</div>